
// middleware

export function subscribeMiddleware({dispatch}) {
    const RECONNECT_DELAY = 20000

    return (next) => (action) => {
        if (action.subscriber) {
            var subscribeTimer

            function subscribe(subscriber) {
                const result = dispatch(subscriber())

                // long polling
                Promise.resolve(result).then(() => {
                    clearTimeout(subscribeTimer)
                    setTimeout(() => subscribe(subscriber), RECONNECT_DELAY)
                }).catch((e) => {
                    clearTimeout(subscribeTimer)
                    setTimeout(() => subscribe(subscriber), RECONNECT_DELAY)
                })
            }

            subscribe(action.subscriber)

            // break middleware chain
            return null
        }
        return next(action)
    }
}

// action

export default function subscribe(subscriber) {
    return {subscriber}
}


// WEBPACK FOOTER //
// ./lib/core/redux/subscribe.js